var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from './Icon';
export var CheckmarkIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M 9.871 15.804 L 16.961 6.525 C 17.13 6.281 17.439 6.241 17.651 6.436 C 17.863 6.631 17.897 6.987 17.727 7.23 L 10.264 17.093 C 10.065 17.355 9.672 17.358 9.47 17.098 L 5.942 12.556 C 5.773 12.313 5.808 11.957 6.02 11.763 C 6.232 11.568 6.541 11.608 6.71 11.852 L 9.871 15.804 Z", fill: "#000" }))); };
//# sourceMappingURL=CheckmarkIcon.js.map